// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { LinkPresentationProps, StyledIcon } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { headerLinkListStyles } from "@tps/Overrides/Widgets/Header/HeaderLinkList";
import IconHeaderUtilityDropdownDown from "@tps/XDL/Icons/IconHeaderUtilityDropdownDown";
import { color, mergeWithCss, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

const sharedMenuLinkStyles: LinkPresentationProps = {
    typographyProps: {
        size: 14,
        weight: 700,
        css: css`
            margin: 0;
            letter-spacing: 0;
            line-height: 22px;
            display: flex;
            align-items: center;
            text-transform: capitalize;
            &&& {
                color: ${color("text.main")};
            }
        `,
    },
    css: css`
        .prev-icon {
            margin-right: 8px;
            &,
            svg {
                width: 14px;
                height: 14px;
                color: ${color("primary.main")};
            }
        }
        &:hover {
            .prev-icon,
            svg {
                color: ${color("common.ui8")};
            }
        }
    `,
};

headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        display: flex;
        margin-left: 30px;
        column-gap: 32px;

        .list-link {
            display: flex;
            align-items: baseline;
        }
    `,
};
headerLinkListStyles.link = {
    ...sharedMenuLinkStyles,
};
headerLinkListStyles.menuLink = {
    ...mergeWithCss<LinkPresentationProps, LinkPresentationProps>(sharedMenuLinkStyles, {
        icon: {
            iconProps: {
                size: 10,
                color: "common.ui4",
                src: IconHeaderUtilityDropdownDown,
                css: css`
                    margin: -3px 0 0 8px;
                    &,
                    svg {
                        width: 8px;
                        height: 10px;
                    }
                `,
            },
            position: "right",
        },
        css: css`
            &[aria-expanded="true"] {
                ${TypographyStyle};
                ${IconWrapper} {
                    color: ${color("common.ui8")};
                }
                ${IconWrapper} {
                    transform: rotate(180deg);
                }
            }
        `,
    }),
};

headerLinkListStyles.menuContent = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};
headerLinkListStyles.menuContentLink = {
    color: "text.main",
    typographyProps: {
        size: 12,
        weight: 400,
        css: css`
            letter-spacing: 0;
            line-height: 13px;
        `,
    },
    css: css`
        &:hover {
            ${TypographyStyle} {
                color: ${color("common.ui8")};
            }
        }
    `,
};
